export const isAnalyzableBusinessOfficer = (officer) => {
    return !!officer.email?.trim() && !!officer.name?.trim() && !!officer.lastName?.trim();
};
